import { observable, configure, action } from 'mobx';
import util from 'preact-util';
import LocalModel from './localModel';

configure({ enforceActions: 'always' });

class VisitorCreditStore extends LocalModel {
    constructor() {
        super('visitorCredit', {
            namePlural: 'visitorCredits',
            namePluralReal: 'visitorcredits',
            sort: '-date',
            limit: 1000,
            api: {
                search: {
                    url: '/api/visitorcredits/',
                    params: {
                        limit: 1000,
                        sort: '-date',
                    },
                },
                load: {
                    url: '/api/visitorcredits/',
                    params: {},
                },
                save: {
                    url: '/api/visitorcredits/',
                    params: {},
                },
                delete: {
                    url: '/api/visitorcredits/',
                    params: {},
                },
            },
        });
    }

    @observable visitorCredits = [];

    @observable visitorCredit = {};

    @observable newVisitorCredit = {};

    @observable searchResults = [];

    @observable total = 0;

    @observable limit = 1000;

    @observable offset = 0;

    @observable currentPage = 1;

    // Balance of the visitor last loaded through loadBalance.
    @observable balance = 0;

    @observable balanceVisitor = 0;

    // Balances keyed by visitor id, for lists that show several visitors.
    @observable balances = {};

    @action
    async loadBalance(visitorId) {
        const id = parseInt(visitorId, 10);
        if (!(id > 0)) {
            return 0;
        }
        const response = await util.fetchApi('/api/visitorcredits/balance', { method: 'GET' }, { visitor: id });
        let balance = 0;
        if (response && response.status === 200 && response.data) {
            balance = response.data.balance || 0;
        }
        this.updateKeyValue('balance', balance);
        this.updateKeyValue('balanceVisitor', id);
        this.updateObjectKeyValue('balances', id, balance);
        return balance;
    }
}

const store = new VisitorCreditStore();
export default store;
